var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { action, observable } from 'mobx';
import { BaseModel } from './../../libraries';
export class BarrageController {
    constructor() {
        this.Model = new BaseModel({ type: 'object' });
        this.barrageState = true;
        this.currentId = 0;
    }
    //弹幕
    get barrageList() {
        return lodash.get(this.Model.value, 'barrageList', []);
    }
    onToggle() {
        this.onClearBarrage();
        this.barrageState = !this.barrageState;
    }
    //清空弹幕
    onClearBarrage() {
        this.Model.set({
            barrageList: [],
        });
    }
    /**
     * @description: 直播间评论监听
     */
    onBarrageListener() {
        Mudu.MsgBus.On(
        // 事件名，值为"Barrage.New"
        'Barrage.New', 
        // 事件处理函数，参数为弹幕对象
        (barrage) => {
            barrage = JSON.parse(barrage);
            if (barrage.text) {
                if (msgParse(barrage.text)) {
                    barrage.text = msgParse(barrage.text);
                    barrage.msg_type = lodash.get(barrage.text, 'msg_type', '10');
                }
                this.Model.set({
                    barrageList: lodash.concat(this.barrageList, [
                        {
                            id: ++this.currentId,
                            // avatar: './static/avatar.jpg',
                            msg: barrage.text,
                            time: 10,
                            type: barrage.msg_type == '10' ? 'text' : 'image',
                        },
                    ]),
                });
            }
        });
    }
}
__decorate([
    observable
], BarrageController.prototype, "barrageState", void 0);
__decorate([
    action.bound
], BarrageController.prototype, "onToggle", null);
function msgParse(msg) {
    try {
        const msgStr = decodeURIComponent(msg);
        const msgObj = JSON.parse(msgStr);
        return msgObj;
    }
    catch (error) {
        return msg;
    }
}
